import {
  AlertCircle,
  BarChart3,
  Calendar,
  CheckCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Download,
  ExternalLink,
  Eye,
  EyeOff,
  Facebook,
  FileText,
  Github,
  Globe,
  Heart,
  HelpCircle,
  Home,
  Image,
  Info,
  Instagram,
  Linkedin,
  Lock,
  LucideIcon,
  Mail,
  MapPin,
  Menu,
  Music,
  Newspaper,
  Phone,
  PieChart,
  Search,
  Settings,
  Share2,
  Star,
  TrendingUp,
  Twitter,
  Unlock,
  Users,
  Video,
  X,
  Zap,
} from 'lucide-react';
import React from 'react';

interface IconRendererProps {
  iconName: string;
  size?: number;
  strokeWidth?: number;
  className?: string;
}

// Map of icon names to lucide-react components
const iconMap: Record<string, LucideIcon> = {
  Home,
  Newspaper,
  Settings,
  Users,
  Mail,
  Phone,
  MapPin,
  Calendar,
  FileText,
  Image,
  Video,
  Music,
  Download,
  Share2,
  Heart,
  Star,
  Search,
  Menu,
  X,
  AlertCircle,
  CheckCircle,
  Info,
  HelpCircle,
  ChevronRight,
  ChevronLeft,
  ChevronDown,
  ChevronUp,
  ExternalLink,
  Lock,
  Unlock,
  Eye,
  EyeOff,
  Zap,
  TrendingUp,
  BarChart3,
  PieChart,
  Globe,
  Github,
  Twitter,
  Facebook,
  Instagram,
  Linkedin,
};

export const IconRenderer: React.FC<IconRendererProps> = ({
  iconName,
  size = 22,
  strokeWidth = 3,
  className = '',
}) => {
  // Get the icon component from the map, fallback to FileText if not found
  const IconComponent = iconMap[iconName] || FileText;

  return <IconComponent size={size} strokeWidth={strokeWidth} className={className} />;
};
